import { useState } from "react";
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";

export default function ChangePassword({ usernameInfo = "", requestSubmitGuard = async () => true }) {

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [strength, setStrength] = useState(0);
  const [strengthText, setStrengthText] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  const checkStrength = (value) => {
    let score = 0;
    if (value.length >= 6) score = 1;
    if (value.length >= 10) score = 2;
    if (value.length >= 14) score = 3;
    if (value.length >= 18) score = 4;

    setStrength(score);

    if (score <= 1) setStrengthText("Password lemah");
    else if (score === 2) setStrengthText("Password cukup");
    else if (score === 3) setStrengthText("Password kuat");
    else setStrengthText("Password sangat kuat");
  };

  const getBarColor = () => {
    if (strength <= 1) return "bg-danger";
    if (strength === 2) return "bg-warning";
    if (strength === 3) return "bg-info";
    return "bg-success";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!String(usernameInfo || "").trim()) {
      setAlert({ type: "danger", message: "Username aktif tidak tersedia. Silakan login ulang." });
      return;
    }
    if (newPassword !== confirmPassword) {
      setAlert({ type: "danger", message: "Konfirmasi password tidak sama" });
      return;
    }
    if (newPassword.length < 6) {
      setAlert({ type: "danger", message: "Password minimal 6 karakter" });
      return;
    }

    setLoading(true);
    setAlert(null);

    try {
      const passed = await requestSubmitGuard("Guard Submit: Ganti Password");
      if (!passed) {
        setLoading(false);
        return;
      }
      const response = await api.put(
        `${backendPort}/api/auth/change-password`,
        { oldPassword, newPassword, username: String(usernameInfo).trim() }
      );

      setAlert({ type: "success", message: response.data.message });
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setStrength(0);
      setStrengthText("");

    } catch (err) {
      setAlert({
        type: "danger",
        message: err.response?.data?.message || "Gagal mengganti password",
      });
    }

    setLoading(false);
  };

  return (
    <div className="w-100">
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="row g-2 align-items-end">
          <div className="col-2">
            <label className="form-label mb-1">Username</label>
            <input
              type="text"
              className="form-control form-control-sm"
              name="change_password_active_username"
              autoComplete="off"
              value={usernameInfo}
              disabled
            />
          </div>

          <div className="col-2">
            <label className="form-label mb-1">Password Lama</label>
            <div className="input-group input-group-sm">
              <input
                type={showOldPassword ? "text" : "password"}
                className="form-control"
                name="change_password_old_password"
                autoComplete="new-password"
                data-lpignore="true"
                data-1p-ignore="true"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowOldPassword((prev) => !prev)}
                aria-label={showOldPassword ? "Sembunyikan password lama" : "Tampilkan password lama"}
              >
                <i className={`bi ${showOldPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </button>
            </div>
          </div>

          <div className="col-2">
            <label className="form-label mb-1">Password Baru</label>
            <div className="input-group input-group-sm">
              <input
                type={showNewPassword ? "text" : "password"}
                className="form-control"
                name="change_password_new_password"
                autoComplete="new-password"
                data-lpignore="true"
                data-1p-ignore="true"
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  checkStrength(e.target.value);
                }}
                required
                minLength={6}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowNewPassword((prev) => !prev)}
                aria-label={showNewPassword ? "Sembunyikan password baru" : "Tampilkan password baru"}
              >
                <i className={`bi ${showNewPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </button>
            </div>
          </div>

          <div className="col-2">
            <label className="form-label mb-1">Konfirmasi Password Baru</label>
            <div className="input-group input-group-sm">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control"
                name="change_password_confirm_password"
                autoComplete="new-password"
                data-lpignore="true"
                data-1p-ignore="true"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                aria-label={showConfirmPassword ? "Sembunyikan konfirmasi password" : "Tampilkan konfirmasi password"}
              >
                <i className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </button>
            </div>
          </div>

          <div className="col"></div>

          <div className="col-2">
            <button className="btn btn-primary btn-sm w-100" disabled={loading}>
              {loading ? "Memproses..." : "Submit"}
            </button>
          </div>
        </div>

        <div className="mt-2 small text-muted">
          <div>Aturan password:</div>
          <div>1. Password lama wajib diisi.</div>
          <div>2. Password baru minimal 6 karakter.</div>
          <div>3. Konfirmasi password baru harus sama persis dengan password baru.</div>
        </div>

        <div className="mt-2">
          <div className="progress" style={{ height: "6px" }}>
            <div
              className={`progress-bar ${getBarColor()}`}
              style={{ width: `${(strength / 4) * 100}%` }}
            ></div>
          </div>
          <small className="text-muted">{strengthText}</small>
        </div>
      </form>

      {alert && (
        <div className={`alert alert-${alert.type} mt-3`}>
          {alert.message}
        </div>
      )}
    </div>
  );
}
